import axios from "axios";
import { useQuery } from "react-query";

export type Cutoff = {
	translation: string;
	lowerLimit: number;
};

export type RunYearInfo = { year: number; cutoffList: Cutoff[] };

export function sortCutoffsByLowerLimit(cutoffList: Cutoff[]): Cutoff[] {
	return [...cutoffList].sort((a, b) => b.lowerLimit - a.lowerLimit);
}

export function getDefaultCutoffLowerLimit(
	cutoffList: Cutoff[] | undefined,
): number | undefined {
	if (!cutoffList?.length) return undefined;
	return Math.max(...cutoffList.map((cutoff) => cutoff.lowerLimit));
}

export function getCutoffTranslation(
	cutoffList: Cutoff[] | undefined,
	lowerLimit: number | undefined,
): string | undefined {
	return cutoffList?.find((cutoff) => cutoff.lowerLimit === lowerLimit)
		?.translation;
}
export const runYearsQueryKey = ["runYears"];
export const runYearsQueryOptions = {
	staleTime: 60 * 60 * 24 * 1000,
	refetchInterval: 60 * 60 * 24 * 1000,
	refetchOnWindowFocus: false,
	refetchOnMount: false,
};

export async function fetchRunYears() {
	const response = await axios.get<RunYearInfo[]>("/planning-api/runyears");
	return response.data;
}

export function getMostRecentNonFutureRunYear(
	runYears: RunYearInfo[] | undefined,
): RunYearInfo | undefined {
	if (!runYears?.length) return undefined;

	const currentYear = new Date().getFullYear();
	const nonFutureRunYears = runYears.filter(
		(runYear) => runYear.year <= currentYear,
	);

	return nonFutureRunYears.reduce<RunYearInfo | undefined>(
		(mostRecent, runYear) => {
			if (!mostRecent || runYear.year > mostRecent.year) {
				return runYear;
			}
			return mostRecent;
		},
		undefined,
	);
}

export function useRunYears() {
	return useQuery(runYearsQueryKey, fetchRunYears, runYearsQueryOptions);
}
